import { gql } from "@apollo/client";

export const GET_ALL_JUSTIFICACION_MOTIVO = gql`
query GetAllJustificacionMotivo {
    allJustificacionMotivo {
        idMotivoJustificacion
        descripcionCorta
    }
}
`;

export const adaptJustificacionMotivo = (justificacionMotivo) => {
  return {
    id: justificacionMotivo?.idMotivoJustificacion,
    displayName: justificacionMotivo?.descripcionCorta
  };
};

export const adaptJustificacionMotivoArray = (
allJustificacionMotivo) =>
{
  return structuredClone(allJustificacionMotivo)?.
  map((justificacionMotivo) => adaptJustificacionMotivo(justificacionMotivo));
};